import { render, staticRenderFns } from "./solicitation.vue?vue&type=template&id=8e2dcbe0&scoped=true"
import script from "./solicitation.vue?vue&type=script&lang=js"
export * from "./solicitation.vue?vue&type=script&lang=js"
import style0 from "./solicitation.vue?vue&type=style&index=0&id=8e2dcbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2dcbe0",
  null
  
)

export default component.exports